// Module
var code = "<div class=\"row search-nav\"> <div class=\"col-sm-4\"><ar-search-nav-toolbar/></div> <div class=\"col-sm-4 text-center\"><ar-search-nav-pagination/></div> <div class=\"col-sm-4 text-right\"><ar-search-nav-order-menu/></div> </div> ";
// Exports
module.exports = code;